export default "__VITE_ASSET__Mxl14VNc__"